import { useState, useEffect } from "react";

const useViewport = (): { width: number; height: number } => {
	const [width, setWidth] = useState(window.innerWidth);
	const [height, setHeight] = useState(window.innerHeight);

	const handleWindowResize = (): void => {
		setWidth(window.innerWidth);
		setHeight(window.innerHeight);
	};

	useEffect(() => {
		window.addEventListener("resize", handleWindowResize);
		return (): void => window.removeEventListener("resize", handleWindowResize);
	}, []);

	return { width, height };
};

export default useViewport;
